/* NDC · Fase 8 · Páginas legacy: índice desde los H2 (≥ N), tablas con scroll propio, tablas de maquetación,
   iframes responsivos. Vanilla, defer. Misma lógica de TOC que ndc-article.js (copiada para no depender de él). */
(function () {
  'use strict';
  var root = document.querySelector('[data-ndc-page]');
  if (!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesktop = window.matchMedia('(min-width: 1100px)');
  var scopes = Array.prototype.slice.call(document.querySelectorAll('[data-ndc-toc-scope]'));

  /* ---------- Tablas: envolver en contenedor con scroll; tablas de maquetación (1 columna o sin bordes) apiladas ---------- */
  scopes.forEach(function (scope) {
    Array.prototype.slice.call(scope.querySelectorAll('table')).forEach(function (t) {
      if (t.closest('.ndc-article__table')) return;
      var rows = t.rows.length, cols = 0;
      for (var i = 0; i < rows; i++) cols = Math.max(cols, t.rows[i].cells.length);
      var hasHead = !!t.querySelector('th');
      var hasImg = !!t.querySelector('img');
      /* tabla usada para maquetar (una columna, o pocas celdas con imágenes y sin cabecera) */
      if (cols === 1 || (!hasHead && hasImg && rows <= 3)) {
        t.setAttribute('data-ndc-layout', '');
        t.classList.add('is-wrapped');
        return;
      }
      var wrap = document.createElement('div');
      wrap.className = 'ndc-article__table';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
      t.classList.add('is-wrapped');
      t.removeAttribute('width');
      t.style.width = '100%';
    });
    /* iframes sin proporción (vídeos embebidos con width/height fijos) */
    Array.prototype.slice.call(scope.querySelectorAll('iframe[width][height]')).forEach(function (f) {
      var w = parseInt(f.getAttribute('width'), 10), h = parseInt(f.getAttribute('height'), 10);
      if (w > 0 && h > 0 && !f.style.aspectRatio) { f.style.aspectRatio = w + ' / ' + h; f.style.width = '100%'; f.style.height = 'auto'; }
    });
    /* imágenes lazy salvo la primera */
    Array.prototype.slice.call(scope.querySelectorAll('img')).forEach(function (img, i) {
      if (i > 0 && !img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  });

  /* ---------- TOC ---------- */
  var toc = root.querySelector('[data-ndc-toc]');
  if (!toc) return;
  var min = parseInt(toc.getAttribute('data-min'), 10) || 4;
  var heads = [];
  scopes.forEach(function (scope) {
    Array.prototype.slice.call(scope.querySelectorAll('h2')).forEach(function (h) {
      if (h.textContent.trim().length > 0 && !h.closest('.ndc-page__cta') && !h.closest('.ndc-pblock--form')) heads.push(h);
    });
  });
  function slugify(s) {
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'seccion';
  }
  if (heads.length < min) { toc.hidden = true; return; }
  var list = toc.querySelector('[data-ndc-toc-list]');
  var used = {}, links = [];
  heads.forEach(function (h, i) {
    var id = h.id;
    if (!id) {
      id = slugify(h.textContent);
      if (used[id]) id += '-' + (i + 1);
      h.id = id;
    }
    used[id] = true;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });
  toc.hidden = false;
  if (mqDesktop.matches) toc.open = true;
  toc.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    var hdr = document.querySelector('#mobile-header.sticky--enabled, .mobile-header.sticky--enabled, .site-header.sticky--enabled, .header-section.sticky--enabled');
    var hdrH = hdr ? hdr.getBoundingClientRect().height : 0;
    var goTo = function (smooth) {
      var top = target.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop) - hdrH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    };
    goTo(!reduced);
    setTimeout(function () { goTo(false); }, reduced ? 60 : 900);
    history.replaceState(null, '', a.getAttribute('href'));
    if (!mqDesktop.matches) toc.open = false;
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'toc_click', section: target.id, page_type: 'page' }); } catch (err) {}
  });
  if ('IntersectionObserver' in window) {
    var active = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var idx = heads.indexOf(en.target);
        if (idx < 0) return;
        if (active) active.classList.remove('is-active');
        active = links[idx];
        active.classList.add('is-active');
      });
    }, { rootMargin: '-10% 0px -70% 0px', threshold: 0 });
    heads.forEach(function (h) { io.observe(h); });
  }
})();
